"use client"

import { Calendar1 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Calendar1Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Calendar1Icon = component(Icon)({ as: Calendar1 })
